import React, { useState } from 'react';
import JavaIcon from '../images/java.png';
import JavaScriptIcon from '../images/js.png';
import HTMLIcon from '../images/html.png';
import CSSIcon from '../images/css-3.png';
import PythonIcon from '../images/python.png';
import SpringBootIcon from '../images/icons8-spring-boot-48.png';
import ReactIcon from '../images/react.png';
import ExpressIcon from '../images/stamp.png';
import SqlIcon from '../images/sql-server.png';
import MavenIcon from '../images/pngwing.com.png';
import GradleIcon from '../images/POSTGRESQL .jpeg';
import NodeJscon from '../images/node-js.png';
import DockerIcon from '../images/docker.jpeg';



function Skills({ setActiveSection }) {
  const [isAboutOpen, setIsAboutOpen] = useState(false);


  return (
    <section id='skills'>
      <div className="flex justify-center items-center min-h-screen">
        <div className={`project-card bg-opacity-100 p-18 rounded-lg shadow-lg w-full md:w-[850px] card ${isAboutOpen ? "active" : ""}`}>
          <h1 className="text-4xl md:text-4xl font-bold mb-2 md:mb-4 text-white items-center">
            Skills I Have Learned
          </h1>
          <div className="icon-container"> 
            <img src={HTMLIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
            <img src={CSSIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
            <img src={JavaScriptIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={JavaIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={PythonIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={ReactIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={NodeJscon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={ExpressIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={SpringBootIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full"/>
          <img src={SqlIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={MavenIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={GradleIcon} alt="Java Icon" className="w-16 h-16 rounded-icon rounded-full" />
          <img src={DockerIcon} alt="Java Icon" className="w-16 h-16 rounded-full" />
            
          </div>
          <div className="mt-8 flex flex-col md:flex-row justify-between space-y-4 md:space-y-0 md:space-x-4">
          <button
            onClick={() => setActiveSection("about")}
            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Go back to Projects Page
            <span className="ml-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 transform rotate-180"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
          </button>
          <button
            onClick={() => setActiveSection("contact")}
            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Go to Contact Me Page
            <span className="ml-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 transform"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
          </button>
        </div>
        </div>
      </div>
    </section>
  );
}

export default Skills;
